<template>
  <div class="cabin-group" style="margin-top: 10px">
    <div v-for="(product, index) in products" v-bind:key="index">
      <div style="position: relative">
        <div style="position: absolute; top: 0px" v-if="product.productLabels && product.productLabels[0]">
          <el-popover placement="right-start" title width="200" trigger="hover" :content="product.productLabels[0].labelText">
            <el-button class="pop-btn" slot="reference" style="line-height: 15px">
              {{ product.productLabels[0].label }}
            </el-button>
          </el-popover>
        </div>
        <ul class="cabin-type">
          <li class="cabin-name" style="justify-content: start; padding-left: 20px">{{ product.productName }}</li>
          <li class="cabin-rule" style="width: 40%">
            <el-popover width="700px" style="margin-right: 0px" trigger="hover" placement="bottom-start" @show="popoverShow('refundPopoverRef' + index)">
              <RefundLuggagesPopoverContent :ref="'refundPopoverRef' + index" :dataItem="product" :showLuggage="false" :refundTips="refundTips" />
              <div slot="reference">退改签规则</div>
            </el-popover>
            <span v-if="product.baggageText" style="margin: 0 5px 0 5px; display: block">|</span>
            <el-popover width="700px" style="margin-right: 0px" trigger="hover" placement="bottom-start" @show="popoverShow('luggagePopoverRef' + index)">
              <RefundLuggagesPopoverContent :ref="'luggagePopoverRef' + index" :dataItem="product" :showRefund="false" />
              <div slot="reference">
                {{ product.baggageText }}
              </div>
            </el-popover>
            <!-- <span style="margin: 0 5px 0 5px; display: block">|</span>
            <span>赠送{{ product.productAmount }}积分</span> -->
          </li>
          <li class="cabin-discount" style="width: 20%"></li>
          <li class="cabin-price" style="justify-content: center !important; widows: 12%">
            <div>
              ¥
              <span style="font-size: 30px">{{ product.productAmount }}</span>
            </div>
          </li>
          <li class="cabin-action" style="width: 14%">
            <!-- 单程预订 -->
            <a href="javascript:void(0)" @click="orderFlight(product, index)">
              <span>预订</span>
              <span>
                {{ product.seats > 9 ? '充足' : ("余" + product.seats + "座") }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import RefundLuggagesPopoverContent from "@/components/RefundLuggagesPopoverContent.vue";
import { checkLogin } from '@/utils/index.js'

export default {
  name: "CabinGroup",
  components: { RefundLuggagesPopoverContent },
  props: {
    flightItem: {
      type: Object,
      default: () => ({})
    },
    products: {
      type: Array,
      default: () => []
    },
    searchFilter: {
      type: Object,
      default: () => ({})
    },
    resultInfo: {
      type: Object,
      default: () => ({})
    },
    refundTips: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  filters: {},
  methods: {
    // 解决tab不能正常渲染的问题
    popoverShow(refName) {
      this.$nextTick(() => {
        this.$refs[refName]?.[0]?.setTabsDefault();
      });
    },
    

    orderFlight(product, index) {
      const check = checkLogin();
      if(!check) return;
      const storeData = { 
        ...this.flightItem, 
        productIndex: index, 
        product, 
        searchFilter: this.resultInfo.requestSegment, 
        snapshotCode: this.resultInfo.snapshotCode,
      }
      sessionStorage.setItem('INT_FLIGHT_ITEM', JSON.stringify(storeData))
      this.$router.push({
        path: "/interPassenger",
        query: { t: new Date().getTime() }
      });
    },

    
  }
};
</script>

<style lang="less" scoped>
.cabin-group {
  background-color: #f8f8f8;
  .pop-btn {
    text-align: center;
    border-radius: 0 10px 10px 0;
    line-height: 30px;
    color: #ffffff;
    border: 0;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cabin-type li {
    padding: 16px 0;
    font-size: 16px;
    text-align: center;
    box-sizing: border-box;
    color: #4d4e4e;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 160px;
    background: #ffffff;
    width: 20%;
  }

  .cabin-type {
    border-bottom: 1px solid #ededed;
    border-right: 1px solid #ededed;
    border-left: 1px solid #ededed;
    display: flex;
  }
  .cabin-name {
    width: 12%;
    font-weight: 700;
  }

  .cabin-rule {
    width: 18%;
  }

  .cabin-rule span {
    display: inline-block;
    font-size: 14px;
    // font-weight: 700;
    color: #aaaaaa;
  }

  .cabin-rule span:first-child {
    margin-right: 12px;
  }
  .cabin-discount {
    width: 10%;
    font-size: 24px;
    justify-content: flex-end !important;
  }
  .cabin-price {
    width: 16%;
    justify-content: flex-end !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #d70039 !important;
  }

  .cabin-action {
    width: 10%;
  }

  .cabin-action a {
    display: inline-block;
    width: 70px;
    height: 50px;
    border: 1px solid #d70039;
    position: absolute;
    right: 20px;
  }

  .cabin-action a span:first-child {
    display: block;
    width: 100%;
    height: 28px;
    font-size: 14px;
    font-weight: 700;
    line-height: 28px;
    color: #fff;
    text-align: center;
    background-color: #d70039;
  }

  .cabin-action a span:last-child {
    display: block;
    width: 100%;
    height: 22px;
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    color: #ab2e2e;
    text-align: center;
  }
}
</style>
